import { createContext, useContext, type ReactNode } from 'react'

/**
 * True when the applicant entered screening via a student-housing property
 * share/QR apply link (`/apply/{token}`). Seeded on property step data in
 * `apply.$token.tsx`; synced to co-applicant apps via `PROPERTY_FACT_KEYS`
 * (`isStudentHousing`). Invited guarantors always get `false` (legacy form)
 * even when guaranteeing a student-housing primary. Use to gate student-only
 * fields across the screening form.
 */
const StudentHousingContext = createContext(false)

export function StudentHousingProvider({
	isStudentHousing,
	children,
}: {
	isStudentHousing: boolean
	children: ReactNode
}) {
	return (
		<StudentHousingContext.Provider value={isStudentHousing}>
			{children}
		</StudentHousingContext.Provider>
	)
}

export function useIsStudentHousing() {
	return useContext(StudentHousingContext)
}
